<template>
  <v-container
    class=" flex-grow-0 filter-container"
    fluid
  >
    <slot name="table-actions">
      <w-row class="filter-container_row d-flex align-center">
        <v-spacer />
        <!--          <w-column cols="auto" v-if="isFilterable">-->
        <!--            <w-clear-filters-button @click="clearFilters($route)" />-->
        <!--          </w-column>-->
        <slot name="inner-table-actions" />
        <w-column
          v-if="allowPresets"
          class="d-flex align-center"
          cols="auto"
        >
          <PresetStateChip
            :preset="preset"
            :filter-card-state="filterCardState"
            @update:preset="(newPreset) => $emit('update:preset', newPreset)"
            @update:filter-card-state="
              (newfilterCardState) =>
                $emit('update:filter-card-state', newfilterCardState)
            "
          />
        </w-column>
        <w-column
          v-if="allowChangeFilters"
          cols="auto"
        >
          <FilterPicker
            :allow-presets="allowPresets"
            :concept="concept"
            :filter-card-state="filterCardState"
            :preset="preset"
            :ordered-filters="orderedFilters"
            :not-visible-filters="notVisibleFilters"
            :available-presets="availablePresets"
            
            @update:not-visible-filters="
              (newNotVisibleFilters) =>
                $emit('update:not-visible-filters', newNotVisibleFilters)
            "
            @update:ordered-filters="
              (newOrderedFilters) =>
                $emit('update:ordered-filters', newOrderedFilters)
            "
            @update:filter-card-state="
              (newfilterCardState) =>
                $emit('update:filter-card-state', newfilterCardState)
            "
            @update:preset="(newPreset) => $emit('update:preset', newPreset)"
          >
            <template slot="default">
              <slot name="searchFilter" />
            </template>

            <template slot="groupSearchFilter">
              <slot name="groupSearchFilter" />
            </template>
          </FilterPicker>
        </w-column>
      </w-row>
    </slot>
  </v-container>
</template>

<script>
export default {
  name: 'BaseLevelFilterHeaderContainer',
  components: {
    PresetStateChip: () =>
      import('@/components/base_components/tables/preset/PresetStateChip'),
    FilterPicker: () =>
      import(
        '@/components/base_components/tables/filter/filter_picker/FilterPicker'
      ),
  },
  props: {
    // feature flags
    allowChangeFilters: { type: Boolean, required: true },
    allowPresets: { type: Boolean, required: true },
    // data
    selectedRows: { type: Array, required: false },
    orderedFilters: { type: Array, required: true },
    notVisibleFilters: { type: Array, required: true },
    concept: { type: String, required: true, default: '' },
    filterCardState: { type: String, required: true },
    preset: { type: Object, required: true },
    availablePresets: { type: Array, required: false },
  },
};
</script>

<style lang="scss" scoped>
.filter-container .filter-container_row .col {
  padding-left: $spacer;
  padding-right: $spacer;
}
</style>
